import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import api from "@/lib/api";
import { telLink } from "@/lib/utils-format";
import WhatsAppCTA from "@/components/WhatsAppCTA";

export default function FloatingCTAs() {
    const [settings, setSettings] = useState({ whatsapp_number: "919971925446", call_number: "+919888438843" });

    useEffect(() => {
        api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
    }, []);

    return (
        <div className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex flex-col items-end gap-3" data-testid="floating-ctas">
            <WhatsAppCTA
                waNumber={settings.whatsapp_number}
                message="Hi, I want the best price for Signia Styletto IX."
                sourcePage="floating-cta"
                className="bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full pl-4 pr-5 py-3 flex items-center gap-2 shadow-[0_18px_40px_-12px_rgba(37,211,102,0.55)] transition-all hover:-translate-y-0.5"
                data-testid="floating-whatsapp-cta"
            >
                <MessageCircle size={20} />
                <span className="hidden sm:inline text-[14px] font-semibold">WhatsApp</span>
            </WhatsAppCTA>
            <a
                href={telLink(settings.call_number)}
                className="bg-[#003E4D] hover:bg-[#002D38] text-white rounded-full pl-4 pr-5 py-3 flex items-center gap-2 shadow-[0_18px_40px_-12px_rgba(0,79,89,0.55)] transition-all hover:-translate-y-0.5"
                data-testid="floating-call-cta"
                aria-label="Call us"
            >
                <Phone size={18} />
                <span className="hidden sm:inline text-[14px] font-semibold">Call</span>
            </a>
        </div>
    );
}
